import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Form, Input } from 'antd';
import FaIcon from '../global/fa-icon/fa-icon';
import api from '../../api';
import { setAuthState } from '../../redux/reducers/auth/auth.actions';
import AppConfig from '../../config';
import _ from 'lodash';


class Login extends Component {

  // NOTE: if you extend propTypes directly in child component class, you will get a react warning.  use _propTypes alias instead
  static propTypes = {
    onAuthChange: PropTypes.func,
  };

  static defaultProps = {
    onAuthChange: _.noop,
  };


  constructor(props) {
    super(props);

    // NOTE: print out the app info data for testing.
    // console.log(JSON.stringify({ ...AppConfig.appInfo, env: AppConfig.env }, null, 2));

    this.state = {
      username: null,
      password: null,
    };

    if (AppConfig.dbgMode) {
      // TODO: joe- debug only
      this.state.username = 'admin';
      this.state.password = 'webdev;';
    }

    this.onUsernameChanged = this.onUsernameChanged.bind(this);
    this.onPasswordChanged = this.onPasswordChanged.bind(this);
    this.onSubmitClicked = this.onSubmitClicked.bind(this);
  }

  onUsernameChanged(e) {
    let value = _.get(e, 'target.value', null);
    this.setState({ username: value });
  }

  onPasswordChanged(e) {
    let value = _.get(e, 'target.value', null);
    this.setState({ password: value });
  }

  async onSubmitClicked() {
    let username = this.state.username;
    let password = this.state.password;
    // console.log('submit clicked ' + JSON.stringify({ username, password }));
    let res = await api.auth.login(username, password);
    // console.log('submit res: ' + JSON.stringify(res, null, 2));

    let session = _.get(res, 'data.session', null);
    let profile = _.get(res, 'data.profile', null);

    if (session && profile) {
      this.props.setAuthState(session, profile, true);
      this.props.history.push('/');
    }
  }


  validateLoginForm() {

  }

  render() {
    return (
      <div className="login">
        <div className="login-prompt modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header no-border">
              <h5 className="modal-title">Sign in to begin</h5>
            </div>
            <div className="modal-body">
              { this.renderLoginForm() }
            </div>
            <div className="modal-footer">
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderLoginForm() {
    let username = this.state.username;
    let password = this.state.password;

    return (
      <Form className="login-form" layout="vertical">

        <div className="row-fluid">
          <div className="col-12">
            <Form.Item
              label="Username"
              name="username"
              rules={[{ required: true, message: 'Please input your username!' }]}
            >
              <Input
                addonBefore={<FaIcon icon="fa-user-alt" />}
                defaultValue={username}
                placeholder="Enter Username"
                onChange={this.onUsernameChanged}
              />
            </Form.Item>
          </div>

          <div className="col-12">
            <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true, message: 'Please input your password!' }]}
            >
              <Input.Password
                addonBefore={<FaIcon icon="fa-lock-alt" />}
                defaultValue={password}
                placeholder="Enter Password"
                onChange={this.onPasswordChanged}
              />
            </Form.Item>
          </div>

          <div className="action-buttons col-12 mt-5">
            <Form.Item>
              <Button type="primary" size="large" htmlType="submit" onClick={this.onSubmitClicked}>Sign in</Button>
            </Form.Item>
          </div>
        </div>


        {/*
        <div className="form-group">

          <label>Email address</label>
          <div className="input-group ">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <FaIcon icon="fa-user-alt" />
              </span>
            </div>
            <input type="email" className="form-control" value={email} placeholder="Enter email" onChange={this.onEmailChanged} />
          </div>

        </div>
        <div className="form-group">
          <label>Password</label>
          <div className="input-group ">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <FaIcon icon="fa-lock-alt" />
              </span>
            </div>
            <input type="password" className="form-control" value={password} placeholder="Password" onChange={this.onPasswordChanged} />
          </div>
        </div>
         */}
      </Form>
    );
  }

}


function mapStateToProps(state) {
  return {
    // auth: state.auth,
  };
}


const mapDispatchToProps = {
  setAuthState,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
